import React, { useState, useEffect } from 'react';
import { getStoreStyle, getStoreCardStyle } from '../utils/storeStyle';

const RegisterCard = () => {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [cardUserId, setCardUserId] = useState(null);
  const [accountName, setAccountName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [referralCode, setReferralCode] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [bgColor, setBgColor] = useState('#f8f8f8');

  useEffect(() => {
    const loadTelegramSDK = () => {
      if (window.Telegram && window.Telegram.WebApp) {
        const tg = window.Telegram.WebApp;
        tg.expand();
        tg.setHeaderColor('#212121');

        const backgroundColor =
          tg.colorScheme === 'dark' ? '#212121' : '#f8f8f8';
        tg.setBackgroundColor(backgroundColor);
        setBgColor(backgroundColor);

        const urlParams = new URLSearchParams(window.location.search);
        const userIdFromUrl = urlParams.get('userId');
        const id = userIdFromUrl || tg.initDataUnsafe?.user?.id || null;

        const username = tg.initDataUnsafe?.user?.username || '';
        setCardUserId(Number(id));
        setAccountName(username);
        setIsLoading(false);
      }
    };

    if (typeof window.Telegram === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-web-app.js';
      script.async = true;
      script.onload = loadTelegramSDK;
      document.body.appendChild(script);
    } else {
      loadTelegramSDK();
    }
  }, []);

  const fetchStores = async () => {
    try {
      setIsLoading(true);
      const response = await fetch('/telegram/store-list');
      const data = await response.json();
      setStores(data);
    } catch (error) {
      alert('Не удалось загрузить список магазинов');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  const handleStoreSelect = (store) => {
    setSelectedStore(store);
    setBirthDate('');
  };

  const handleBackToStores = () => {
    setSelectedStore(null);
    setName('');
    setSurname('');
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    if (!name || !surname) {
      alert('Заполните все поля!');
      return;
    }

    if (selectedStore.collectBirthDate && !birthDate) {
      alert('Укажите дату рождения');
      return;
    }

    if (!cardUserId) {
      alert('Ошибка: не удалось получить ID пользователя Telegram.');
      return;
    }

    const requestData = {
      name,
      surname,
      cardUserId,
      accountName,
      user: selectedStore._id,
      ...(birthDate ? { birthDate: birthDate.slice(5) } : {}),
      ...(referralCode ? { referralCodeInput: referralCode.trim() } : {}),
    };

    try {
      const response = await fetch('/telegram/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (data.cardNumber) {
        alert(`🎉 Ваша карта: ${data.cardNumber}`);
        window.Telegram.WebApp.close();
      } else {
        alert('Ошибка при регистрации карты.');
      }
    } catch (error) {
      console.error('Ошибка при отправке запроса:', error);
      alert('Ошибка сервера. Попробуйте позже.');
    }
  };

  if (isLoading) {
    return (
      <div className="container-registration">
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!selectedStore) {
    return (
      <div className="container-stores" style={{ backgroundColor: bgColor }}>
        <h2 className="stores-title">Выберите магазин</h2>
        <div className="stores-list">
          {stores.map((store) => {
            const style = getStoreStyle(store);
            return (
              <div
                key={store._id}
                className="store-card card-surface-plastic"
                onClick={() => handleStoreSelect(store)}
                style={getStoreCardStyle(store)}
              >
                <div className="store-logo-container">
                  <img
                    src={style.logoUrl}
                    alt={store.accountName}
                    className="store-logo"
                  />
                </div>
                <div className="store-info">
                  <h3 className="store-name" style={{ color: style.textColor }}>
                    {store.accountName}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  const selectedStyle = getStoreStyle(selectedStore);

  return (
    <div
      className="container-registration"
      style={{ backgroundColor: bgColor }}
    >
      <form className="registration-form" onSubmit={handleRegister}>
        <div className="form-header">
          <button
            type="button"
            className="back-button"
            onClick={handleBackToStores}
          >
            ← Назад
          </button>
        </div>

        <div
          className="selected-store card-surface-plastic"
          style={getStoreCardStyle(selectedStore)}
        >
          <div className="selected-store-logo">
            <img
              src={selectedStyle.logoUrl}
              alt={selectedStore.accountName}
              className="store-logo"
            />
          </div>
          <p className="selected-store-name" style={{ color: selectedStyle.textColor }}>
            {selectedStore.accountName}
          </p>
        </div>

        <div className="form-group">
          <label style={{ color: selectedStyle.labelColor }}>Имя:</label>
          <input
            type="text"
            placeholder="Введите имя"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label style={{ color: selectedStyle.labelColor }}>Фамилия:</label>
          <input
            type="text"
            placeholder="Введите фамилию"
            value={surname}
            required
            onChange={(e) => setSurname(e.target.value)}
          />
        </div>

        {selectedStore.referralEnabled && (
          <div className="form-group">
            <label style={{ color: selectedStyle.labelColor }}>Код друга (необязательно):</label>
            <input
              type="text"
              placeholder="Например, AB3K7MNP"
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
              autoCapitalize="characters"
              spellCheck={false}
            />
          </div>
        )}

        {selectedStore.collectBirthDate && (
          <div className="form-group">
            <label style={{ color: selectedStyle.labelColor }}>Дата рождения:</label>
            <input
              type="date"
              value={birthDate}
              required
              onChange={(e) => setBirthDate(e.target.value)}
            />
          </div>
        )}

        <button type="submit" className="register-button">
          Зарегистрировать карту
        </button>
      </form>
    </div>
  );
};

export default RegisterCard;
